define('app/collections/produtos',['require','backbone','rb','../collections/posicoes','../collections/tipos','../models/busca','../models/paginacao'],function(require){
    var Backbone = require('backbone');
    var R = require('rb');
    
    var posicoes = require('../collections/posicoes');
    var tipos = require('../collections/tipos');
    var busca = require('../models/busca');
    var paginacao = require('../models/paginacao');
    var produtos = new Backbone.Collection();
    
    var resetPaginacao = function() {
        produtos.set([]);
        paginacao.set({
            page:1
        });
    };
    
    
    var timer = null;
    var loadProdutos = function() {
        if (timer) {
            window.clearTimeout(timer);
        }
        
        timer = window.setTimeout(function(){
            
            window.jQuery.fancybox.showLoading();
            
            var where = [];
            var values = [];
            var joins = [];
            
            var WherePosicao = [];
            var addPosicao = 0
            
            where.push("produto.deleted = 0");
            where.push("produto.ativo = 1");
            
            if (busca.get('novo')) {
                where.push("produto.novo = 1");
            }
            if (busca.get("sale")) {
                where.push("produto.sale = 1");
            }
            if (busca.get('referencia')!='') {
                var keywords = $.trim(busca.get('referencia').replace(/\s+/igm,' ')).split(' ');
                keywords.forEach(function(keyword){
                    where.push("(produto.referencia like '%"+keyword+"%' or produto.titulo like '%"+keyword+"%')");
                });
            }
            if (posicoes.length != 0) {
                posicoes.each(function(posicao){
                    if (posicao.get('checked')) {                    
                        //where.push("(select count(0) from produtoposicao where produtoposicao.deleted=0 and produtoposicao.produto_id=produto.id and produtoposicao.posicao_id=?) != 0");
                        WherePosicao.push("(select count(0) from produtoposicao where produtoposicao.deleted=0 and produtoposicao.produto_id=produto.id and produtoposicao.posicao_id=?) != 0");
                        values.push(posicao.get('id'));
                        addPosicao = 1;
                    }
                });
                if (addPosicao == 1) {
                    var WherePosicao = WherePosicao.join(" or ");
                    where.push(WherePosicao);
                }
            }
            
            if (tipos.length != 0) {
                tipos.each(function(tipo){
                    if (tipo.get('checked')) {                    
                        where.push("(select count(0) from produtotipo where produtotipo.deleted=0 and produtotipo.produto_id=produto.id and produtotipo.tipo_id=?) != 0");
                        values.push(tipo.get('id'));
                    }
                });
            }
            
            var where = where.join(" and ");
            
            var page = paginacao.get('page')|0;
            if (page < 1) page = 1;
            
            var rows = paginacao.get('rows')|0;
            if (rows < 1) rows = 21;
            
            var offset = (page -1) * rows;
            
            
            
            R.getAll("SELECT * FROM (SELECT \
                produto.id, \
                produto.titulo, \
                produto.ordenamento, \
                produto.novo, \
                produto.sale, \
                produto.porcentagem, \
                (select produtoarquivo.path from produtoarquivo where produtoarquivo.deleted=0 and produtoarquivo.produto_id=produto.id order by produtoarquivo.destaque desc, produtoarquivo.ordenamento desc limit 1) as imagem \
                FROM \
                produto \
                WHERE "+where+") as produto \
                WHERE produto.imagem!='' \
                ORDER BY produto.ordenamento DESC \
                ",values).done(function(err,rows) {
                    if (err) {
                        console.log(err);
                        return;
                    }
                    produtos.set(rows.map(function(row){
                        row.id = row.id|0;
                        row.novo = row.novo|0;
                        row.sale = row.sale|0;
                        row.porcentagem = row.porcentagem|0;
                        return row;
                    }));      
                    window.jQuery.fancybox.hideLoading();
                });
            },100);
        };
        
        loadProdutos();
        
        posicoes.on('all',function(){
            resetPaginacao();
            loadProdutos();
        });
        tipos.on('all',function() {
            resetPaginacao();
            loadProdutos();
        });
        busca.on('all',function() {
            resetPaginacao();
            loadProdutos();
        });
        paginacao.on('all',function(){
            loadProdutos();
        });
        
        
        return produtos;
    });
